"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bugfender = void 0;
var log_1 = require("./types/log");
var issue_1 = require("./types/issue");
var Bugfender = (function () {
    function Bugfender(featureDetection, provider, sdkOptions, window) {
        this.featureDetection = featureDetection;
        this.provider = provider;
        this.sdkOptions = sdkOptions;
        this.window = window;
        this.LogLevel = log_1.LogLevel;
    }
    Bugfender.prototype.init = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, browser, _l, _m, _o, _p;
            var _this = this;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        this.options = this.sdkOptions.init(options);
                        this.provider.setOptions(this.options);
                        this.device = this.provider.getDevice();
                        _a = this;
                        return [4, this.provider.getPrintToConsole()];
                    case 1:
                        _a.printToConsole = _q.sent();
                        _b = this;
                        return [4, this.provider.getStorageProcessor()];
                    case 2:
                        _b.processor = _q.sent();
                        _c = this;
                        return [4, this.provider.getResetStorage()];
                    case 3:
                        _c.resetStorage = _q.sent();
                        _d = this;
                        return [4, this.provider.getCurrentSession()];
                    case 4:
                        _d.session = _q.sent();
                        _e = this;
                        return [4, this.provider.getStorageWriterHub()];
                    case 5:
                        _e.storage = _q.sent();
                        _f = this;
                        return [4, this.provider.getUserFeedback()];
                    case 6:
                        _f.userFeedback = _q.sent();
                        this.logger = this.provider.getLogger('Bugfender');
                        _h = (_g = this.logger).log;
                        _j = ['DEBUG'];
                        _k = {
                            debug: this.options.debug
                        };
                        return [4, this.featureDetection.isIndexedDBSupported()];
                    case 7:
                        _k.indexDB = _q.sent(),
                            _k.localStorage = this.featureDetection.isLocalStorageSupported();
                        return [4, this.featureDetection.isMultiTabSupported()];
                    case 8:
                        _h.apply(_g, _j.concat([(_k.multiTab = _q.sent(),
                                _k.sessionStorage = this.featureDetection.isSessionStorageSupported(),
                                _k.worker = this.featureDetection.isWorkerSupported(),
                                _k)]));
                        return [4, this.resetStorage.resetIfAppChanged(this.options.appID)];
                    case 9:
                        _q.sent();
                        this.storage.init(this.options);
                        browser = this.device.getBrowserInfo();
                        this.storage.addDeviceKey('$browser', browser.getBrowserName());
                        if (!this.options.logBrowserEvents) return [3, 11];
                        _l = this;
                        return [4, this.provider.getRegisterBrowserEventsHandler()];
                    case 10:
                        _l.registerBrowserEventsHandler = _q.sent();
                        this.registerBrowserEventsHandler.init();
                        _q.label = 11;
                    case 11:
                        if (!this.options.logUIEvents) return [3, 13];
                        _m = this;
                        return [4, this.provider.getRegisterUIEventsHandler()];
                    case 12:
                        _m.registerUIEventsHandler = _q.sent();
                        this.registerUIEventsHandler.init();
                        _q.label = 13;
                    case 13:
                        if (!this.options.registerErrorHandler) return [3, 15];
                        _o = this;
                        return [4, this.provider.getRegisterErrorHandler()];
                    case 14:
                        _o.registerErrorHandler = _q.sent();
                        this.registerErrorHandler.init(this);
                        _q.label = 15;
                    case 15:
                        if (!this.options.overrideConsoleMethods) return [3, 17];
                        _p = this;
                        return [4, this.provider.getOverrideConsoleMethods()];
                    case 16:
                        _p.overrideConsoleMethods = _q.sent();
                        this.overrideConsoleMethods.init();
                        _q.label = 17;
                    case 17:
                        this.printToConsole.init(this.options.printToConsole);
                        window.addEventListener('beforeunload', function () {
                            _this.processor.run();
                        });
                        return [2];
                }
            });
        });
    };
    Bugfender.prototype.getDeviceURL = function () {
        var _a, _b, _c;
        return ((_a = this.options) === null || _a === void 0 ? void 0 : _a.baseURL) + "/intent/" + ((_b = this.options) === null || _b === void 0 ? void 0 : _b.appID) + "/device/" + ((_c = this.device) === null || _c === void 0 ? void 0 : _c.getUDID());
    };
    Bugfender.prototype.getSessionURL = function () {
        var _a, _b, _c;
        return ((_a = this.options) === null || _a === void 0 ? void 0 : _a.baseURL) + "/intent/" + ((_b = this.options) === null || _b === void 0 ? void 0 : _b.appID) + "/session/" + ((_c = this.session) === null || _c === void 0 ? void 0 : _c.getUUID());
    };
    Bugfender.prototype.getUserFeedback = function (options) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2, (_a = this.userFeedback) === null || _a === void 0 ? void 0 : _a.show(options)];
            });
        });
    };
    Bugfender.prototype.log = function () {
        var _a, _b;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogMessage(log_1.LogLevel.Debug, __spreadArrays(parameters));
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.log.apply(_b, parameters);
    };
    Bugfender.prototype.warn = function () {
        var _a, _b;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogMessage(log_1.LogLevel.Warning, __spreadArrays(parameters));
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.warn.apply(_b, parameters);
    };
    Bugfender.prototype.error = function () {
        var _a, _b;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogMessage(log_1.LogLevel.Error, __spreadArrays(parameters));
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.error.apply(_b, parameters);
    };
    Bugfender.prototype.trace = function () {
        var _a, _b;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogMessage(log_1.LogLevel.Trace, __spreadArrays(parameters));
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.trace.apply(_b, parameters);
    };
    Bugfender.prototype.info = function () {
        var _a, _b;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogMessage(log_1.LogLevel.Info, __spreadArrays(parameters));
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.info.apply(_b, parameters);
    };
    Bugfender.prototype.fatal = function () {
        var _a, _b;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogMessage(log_1.LogLevel.Fatal, __spreadArrays(parameters));
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.error.apply(_b, parameters);
    };
    Bugfender.prototype.removeDeviceKey = function (key) {
        var _a, _b;
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addDeviceKey(key, null);
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.info("Device key \"" + key + "\" removed");
    };
    Bugfender.prototype.sendLog = function (log) {
        var _a, _b;
        log.url = log.url || (this.window) ? this.window.location.href : '';
        (_a = this.storage) === null || _a === void 0 ? void 0 : _a.addLogEntry(log);
        (_b = this.printToConsole) === null || _b === void 0 ? void 0 : _b.printLog(log);
    };
    Bugfender.prototype.sendIssueMarkdown = function (title, markdown) {
        var _a, _b;
        (_a = this.printToConsole) === null || _a === void 0 ? void 0 : _a.warn("Issue: " + title + ".\n" + markdown);
        return (_b = this.storage) === null || _b === void 0 ? void 0 : _b.addIssue(issue_1.IssueType.Issue, title, markdown);
    };
    Bugfender.prototype.sendIssue = function (title, text) {
        var _a, _b;
        (_a = this.printToConsole) === null || _a === void 0 ? void 0 : _a.warn("Issue: " + title + ".\n" + text);
        var markdown = '```\n' + text + '\n```';
        return (_b = this.storage) === null || _b === void 0 ? void 0 : _b.addIssue(issue_1.IssueType.Issue, title, markdown);
    };
    Bugfender.prototype.sendCrash = function (title, text) {
        var _a, _b;
        (_a = this.printToConsole) === null || _a === void 0 ? void 0 : _a.error("Crash: " + title + ".\n" + text);
        var markdown = '```\n' + text + '\n```';
        return (_b = this.storage) === null || _b === void 0 ? void 0 : _b.addIssue(issue_1.IssueType.Crash, title, markdown);
    };
    Bugfender.prototype.sendUserFeedback = function (title, markdown) {
        var _a, _b;
        (_a = this.printToConsole) === null || _a === void 0 ? void 0 : _a.info("User Feedback: " + title + ".\n" + markdown);
        return (_b = this.storage) === null || _b === void 0 ? void 0 : _b.addIssue(issue_1.IssueType.Feedback, title, markdown);
    };
    Bugfender.prototype.setDeviceKey = function (key, value) {
        var _a, _b;
        (_a = this.printToConsole) === null || _a === void 0 ? void 0 : _a.info("Device key \"" + key + "\" set to \"" + value + "\"");
        (_b = this.storage) === null || _b === void 0 ? void 0 : _b.addDeviceKey(key, value);
    };
    return Bugfender;
}());
exports.Bugfender = Bugfender;
